import { Injectable, signal, computed } from '@angular/core';
import { AnnouncementBannerConfig } from '../interfaces/announcemnt-banner-config';

@Injectable({
    providedIn: 'root'
})
export class BannerConfigService {
    private readonly _banners = signal<AnnouncementBannerConfig[]>([]);
    readonly banners = this._banners.asReadonly();

    setConfig(config: AnnouncementBannerConfig[]) {
        const confItems = Object.freeze(config.map(item => Object.freeze({ ...item }))) as AnnouncementBannerConfig[];
        this._banners.set(confItems);
    }

    getBannersByTeam(team: 'banking' | 'investments') {
        return computed(() => this._banners().filter(banner => banner.team === team));
    }
}